import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, glowSm, glowMd, shimmerKeyframes } from './glowUtil'
import { DOT_PREFIX } from './constant'

const transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'

export default genComponentStyleHook(['Button', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 2,
      fontWeight: 500,
      letterSpacing: '0.5px',
      textTransform: 'uppercase' as const,
      fontSize: '13px',

      [`&${componentCls}-primary`]: {
        [`&:not(${componentCls}-dangerous)`]: {
          background: `transparent !important`,
          border: `1px solid ${cyan[500]} !important`,
          color: `${cyan[500]} !important`,
          boxShadow: glowSm,
          position: 'relative' as const,
          overflow: 'hidden',

          '&:after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(105deg, transparent 40%, ${cyan[500]}15 45%, ${cyan[500]}25 50%, ${cyan[500]}15 55%, transparent 60%)`,
            backgroundSize: '200% 100%',
            animationName: shimmerKeyframes,
            animationDuration: '4s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'ease-in-out',
            pointerEvents: 'none',
          },

          '&:not(:disabled):hover': {
            background: `${cyan[500]}15 !important`,
            boxShadow: glowMd,
            borderColor: `${cyan[400]} !important`,
            color: `${cyan[400]} !important`,
            transform: 'translateY(-1px)',
          },
          '&:not(:disabled):active': {
            background: `${cyan[500]}25 !important`,
            transform: 'translateY(0) scale(0.98)',
            boxShadow: glowSm,
          },
          '&:disabled': {
            opacity: 0.35,
            '&:after': { display: 'none' },
          },
        },
      },

      [`&${componentCls}-default`]: {
        [`&:not(${componentCls}-dangerous)`]: {
          background: `rgba(15, 23, 42, 0.6) !important`,
          borderColor: `${cyan[500]}30 !important`,
          color: `${cyan[200]} !important`,

          '&:not(:disabled):hover': {
            borderColor: `${cyan[500]}70 !important`,
            color: `${cyan[500]} !important`,
            boxShadow: `0 0 8px ${cyan[500]}25`,
            transform: 'translateY(-1px)',
          },
          '&:not(:disabled):active': {
            borderColor: `${cyan[600]} !important`,
            transform: 'translateY(0)',
          },
        },
      },

      [`&${componentCls}-text, &${componentCls}-link`]: {
        '&:not(:disabled):hover': {
          color: `${cyan[500]} !important`,
          background: `${cyan[500]}08 !important`,
        },
      },
    },
  }
})
